import React, { useContext, useEffect } from 'react';
import { BasicPageContainer } from 'components/views/BasicPageContainer';
import { CircularProgress, Divider } from '@mui/material';
import { UserDataSection } from 'components/views/profile/UserDataSection/UserDataSection';
import { UserProfileHeader } from 'components/views/profile/UserProfileHeader';
import { LogingInSection } from 'components/views/profile/LogingInSection/LogingInSection';
import { OrganizationInfoSection } from 'components/views/profile/OrganizationInfoSection';
import { UserProfileViewContextProvider } from 'context/userProfile/UserProfileViewContextProvider';
import { UserProfileViewContext } from 'context/userProfile/UserProfileViewContext';
import { useLocation, useNavigate } from 'react-router-dom';
import { RoutePaths } from 'constants/RoutePaths';
import { useAuthContext } from 'hooks/useAuthContext';

const UserProfileViewContent = () => {
    const { user, getProfilePending } = useContext(UserProfileViewContext);
    const { userState } = useAuthContext();
    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    const userId = queryParams.get('userId');

    useEffect(() => {
        if (userState?.user?.userId && userId && userState.user.userId === userId) {
            navigate(RoutePaths.PROFILE);
        }
    }, [userState?.user.userId, userId, navigate]);

    return getProfilePending || !user
    ? <CircularProgress/>
    : <BasicPageContainer>
        <UserProfileHeader />
        <Divider />
        <UserDataSection/>
        <Divider />
        <LogingInSection user={user}/>
        <Divider />
        <OrganizationInfoSection organizationName={user.workspace.name} patronNames={user.patrons.map(p => p.displayName)} userRole={user.role} tagA={user.tagA || ''} tagB={user.tagB || ''} />
    </BasicPageContainer>
}

export const UserProfileView = () => {
    return <UserProfileViewContextProvider>
        <UserProfileViewContent />
    </UserProfileViewContextProvider>
}